export default "__VITE_ASSET__c1e3d34b__"